App.CoordinatesTransform = DS.Transform.extend
  serialize: (coordinates) ->
    return unless coordinates
    "POINT (#{coordinates.lon} #{coordinates.lat})"

  deserialize: (pointString) ->
    unless pointString
      return {
        lat: null
        lon: null
      }

    matchPoint = /(\d*\.\d*)/g
    point = pointString.match(matchPoint).map((n) => parseFloat(n))
    {
      lat: Number(point[1])
      lon: Number(point[0])
    }